'AttachmentMaint'.maint({panelStyle: "titled", icon: 'Paperclip'})
'Add Attachment'.title({when: 'adding'})
'Edit Attachment'.title({when: 'editing'})
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Save'.action({act: 'save'})
'Attachment'.datatype()

''.panel()
'documentType'.field({readOnly: true})
'datatype'.field({readOnly: true})
'theParentId'.field({hidden: true})
'parentReference'.field({readOnly: true, showAsLink: true})
'attachmentType'.field()
'description'.field()
'attachedDate'.field({date: true, readOnly: true})
'contents'.field()
'fileName'.field({readOnly: true})

'AttachmentMaint'.warning(async (maint, attachment) => {
  if ( attachment.attachmentType !== 'Serial Numbers' ) return
  let fileName = attachment.contents; if ( ! fileName ) return
  fileName = fileName.toLowerCase()
  if ( ! (fileName.endsWith('.csv') || fileName.endsWith('.txt')) )
    return "This attachment will not be searchable (Only CSV and TXT files are searchable)"
})

'parentReference'.destination(async attachment => {
  return await attachment.toParent()
})

'AttachmentMaint'.makeDestinationFor('Attachment')

'fileName'.visibleWhen((maint, attachment) => {
  return attachment.fileName ? true : false
})

'AttachmentMaint'.whenAdding(async function(attachment, maint) {
  let cast = maint.callerCast(); if ( ! cast ) return
  attachment.datatype = cast.datatype()
  attachment.theParentId = cast.id
  if ( cast.supplier ) {
    let supplier = await cast.referee('supplier')
    if ( supplier )
      attachment.entityName = supplier.name
  }
  let order
  if ( cast.datatype() === 'orders' )
    order = cast
  else {
    if ( cast.toOrder )
      order = await cast.toOrder()
    else if ( cast.order )
      order = await cast.referee('order')
  }
  if ( order ) {
    let customer = await order.toCustomer()
    if ( customer ) {
      attachment.entityName = customer.display_name
      attachment.customerId = customer.id
    } else {
      attachment.entityName = order.billingName
    }
  }
})

'contents'.afterChoosingFile(async (maint, files) => {
  let attachment = maint.mainCast(); if ( ! attachment ) return
  if ( files.length !== 1 ) {
    maint.app().showMessage('Please select a single file')
    return
  }
  let f = files[0]
  let reader = new FileReader()
  reader.onload = function(e) {
    attachment.contents = btoa(e.target.result)
    attachment.__fileName = f.name
    attachment.fileName = f.name
  }
  reader.readAsBinaryString(f);
})


